module.exports = __webpack_public_path__ + "bf1.no1.e503529f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/bf1.no1.jpg
// module id = fO2f
// module chunks = 0